export function grpopup() {
  $('#gr').append(`
    <div class="gr-btns">
        <button data-popup="0" popovertarget="gr-popup" popovertargetaction="show">一般客室（客室備品）</button>
        <button data-popup="1" popovertarget="gr-popup" popovertargetaction="show">一般客室 アメニティ（館内配布）</button>
    </div>
    <div id="gr-popup" popover>
      <div class="gr-outer">
        <div class="gr-inner">
          <button popovertarget="gr-popup" popovertargetaction="hide" class="gr-close"></button>
          <div class="gr-tab">
            <nav class="gr-tab-btns">
              <button>一般客室（客室備品）</button>
              <button>一般客室 アメニティ（館内配布）</button>
            </nav>
            <div class="gr-cont">
              <div>
                <dl>
                  <dt>【料理器具】</dt>
                  <dd>炊飯器、電子レンジ、電気ポット、まな板・包丁、カセットコンロ、お玉、フライ返し、菜箸、ザル、ボウル、計量カップ、鍋・フライパン</dd>
                </dl>
                <dl>
                  <dt> 【キッチン用品】</dt>
                  <dd>台所用洗剤、台所用スポンジ、紙布巾</dd>
                </dl>
                <dl>
                <dt></dt>
                <dd> Wi-Fi（無料） / 個別空調エアコン / 目覚まし時計 /洗浄機能付トイレ / ドライヤー / バスタオル / フェイスタオル / テレビ / 電話 / 冷蔵庫 / スリッパ</dd>
                </dl>
              </div>
              <div>
                <dl>
                  <dt>一般客室 アメニティ（館内配布）</dt>
                  <dd> カミソリ、歯ブラシ、浴衣、帯、シェーバー、コットン、シャワーキャップ、お茶（ティーパック）</dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `);

  $('#grpt').append(`
    <div class="gr-btns">
        <button data-popup="0" popovertarget="grpet-popup" popovertargetaction="show">客室備品</button>
        <button data-popup="1" popovertarget="grpet-popup" popovertargetaction="show">アメニティ（館内配布）</button>
    </div>
    <div id="grpet-popup" popover>
      <div class="gr-outer">
        <div class="gr-inner">
          <button popovertarget="grpet-popup" popovertargetaction="hide" class="gr-close"></button>
          <div class="gr-tab">
            <nav class="gr-tab-btns">
              <button>客室備品</button>
              <button>アメニティ（館内配布）</button>
            </nav>
            <div class="gr-cont">
              <div>
                <dl>
                  <dt>【料理器具】</dt>
                  <dd>冷蔵庫、電子レンジ、ケトル、フライパン、片手鍋 Wi-Fi（無料） / 個別空調エアコン / 目覚まし時計 /洗浄機能付トイレ / ドライヤー / バスタオル / フェイスタオル / テレビ / 電話 /冷蔵庫 /スリッパ</dd>
                </dl>
                <dl>
                  <dt>【ユニットバス】</dt>
                  <dd>シャンプー/コンディショナー/ボディソープ/ハンドソープ／洗面コップ</dd>
                </dl>
                <dl>
              </div>
              <div>
                <dl>
                  <dt>一般客室 アメニティ（館内配布）</dt>
                  <dd>カミソリ、歯ブラシ、浴衣、帯、シェーバー、コットン、シャワーキャップ、お茶（ティーパック）</dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `);

  // const tab = $('.gr-tab-btns > button');
  const cont = $('#gr-popup .gr-cont > div,#grpet-popup .gr-cont > div');

  $('.gr-btns > button').on('click', function () {
    const idx = $(this).data('popup');
    const tab = $(this).parents('.gr-btns').next('div').find('.gr-tab-btns > button');
    const cont = $(this).parents('.gr-btns').next('div').find('.gr-tab-btns + .gr-cont > div');
    tab.removeClass('on');
    tab.eq(idx).addClass('on');
    cont.removeClass('on');
    cont.eq(idx).addClass('on');
    tab.on('click', function () {
      const btn = $(this);
      btn.siblings().removeClass('on');
      btn.addClass('on');
      cont.removeClass('on');
      cont.eq(btn.parent().children().index(this)).addClass('on');
    });
  });
}
